import { APP_INFO } from './action-types'

export const updateAppInfo = appInfo => ({
  type: APP_INFO,
  value: appInfo,
})

export const fetchAppInfo = dispatch => {
  const pollFunc = () =>
    fetch('/info')
      .then(r => r.json())
      .then(appInfo => dispatch(updateAppInfo(appInfo)))
      .catch(() => dispatch(updateAppInfo({})))

  pollFunc()
  setInterval(pollFunc, 30000)
}
